var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItineraryHotel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hotel 1",
    clipPath: "url(#clip0_3748_57269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3748_57269",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path810",
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3748_57269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path814",
    d: "M4.46875 23.2969H19.5313V4.46874H4.46875V23.2969Z",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path818",
    d: "M19.5313 2.20938C19.5313 1.80986 19.3727 1.42689 19.09 1.14447C18.8075 0.861672 18.4246 0.703141 18.025 0.703141H5.97503C5.57547 0.703141 5.1925 0.861672 4.91008 1.14447C4.62733 1.42689 4.46875 1.80986 4.46875 2.20938V4.46875H19.5313V2.20938Z",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path820",
    d: "M10.4937 23.2969H13.5062V18.7781H10.4937V23.2969Z",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path824",
    d: "M7.48145 7.48128V8.23438",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path828",
    d: "M10.4937 7.48128V8.23438",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path832",
    d: "M13.5063 7.48128V8.23438",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path836",
    d: "M16.5186 7.48128V8.23438",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path840",
    d: "M7.48145 11.2469V12",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path844",
    d: "M10.4937 11.2469V12",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path848",
    d: "M13.5063 11.2469V12",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path852",
    d: "M16.5186 11.2469V12",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path856",
    d: "M7.48145 15.0125V15.7656",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path860",
    d: "M10.4937 15.0125V15.7656",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path864",
    d: "M13.5063 15.0125V15.7656",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path868",
    d: "M16.5186 15.0125V15.7656",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path872",
    d: "M7.48145 18.7782V19.5312",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path876",
    d: "M16.5186 18.7782V19.5312",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path880",
    d: "M0.703125 23.2969H23.2969",
    stroke: "#FF9F43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3748_57269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItineraryHotel);
export default __webpack_public_path__ + "static/media/itinerary-hotel.47166cf8.svg";
export { ForwardRef as ReactComponent };